/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedAfrRouteImport } from './routes/_authenticated/afr'
import { Route as AuthenticatedAttendanceRouteImport } from './routes/_authenticated/attendance'
import { Route as AuthenticatedBankAccountsRouteImport } from './routes/_authenticated/bank-accounts'
import { Route as AuthenticatedClientGroupsRouteImport } from './routes/_authenticated/client-groups'
import { Route as AuthenticatedCompaniesRouteImport } from './routes/_authenticated/companies'
import { Route as AuthenticatedContactsRouteImport } from './routes/_authenticated/contacts'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedEmployeesRouteImport } from './routes/_authenticated/employees'
import { Route as AuthenticatedInvoiceNotesRouteImport } from './routes/_authenticated/invoice-notes'
import { Route as AuthenticatedLeaveRouteImport } from './routes/_authenticated/leave'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedPayslipsRouteImport } from './routes/_authenticated/payslips'
import { Route as AuthenticatedServiceBundlesRouteImport } from './routes/_authenticated/service-bundles'
import { Route as AuthenticatedServicesRouteImport } from './routes/_authenticated/services'
import { Route as AuthenticatedVirrginRouteImport } from './routes/_authenticated/virrgin'
import { Route as AuthenticatedWorkLogRouteImport } from './routes/_authenticated/work-log'
import { Route as AuthenticatedAdminPayrollSettingsRouteImport } from './routes/_authenticated/admin/payroll-settings'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedBulkActionsIndexRouteImport } from './routes/_authenticated/bulk-actions.index'
import { Route as AuthenticatedBulkActionsActionIdRouteImport } from './routes/_authenticated/bulk-actions.$actionId'
import { Route as AuthenticatedClientGroupsGroupIdRouteImport } from './routes/_authenticated/client-groups_.$groupId'
import { Route as AuthenticatedCompaniesCompanyIdRouteImport } from './routes/_authenticated/companies_.$companyId'
import { Route as AuthenticatedFeeSchedulesIndexRouteImport } from './routes/_authenticated/fee-schedules.index'
import { Route as AuthenticatedFeeSchedulesScheduleIdRouteImport } from './routes/_authenticated/fee-schedules.$scheduleId'
import { Route as AuthenticatedInvoiceRunsRunIdRouteImport } from './routes/_authenticated/invoice-runs.$runId'
import { Route as AuthenticatedInvoicesIndexRouteImport } from './routes/_authenticated/invoices.index'
import { Route as AuthenticatedInvoicesInvoiceIdRouteImport } from './routes/_authenticated/invoices.$invoiceId'
import { Route as AuthenticatedInvoicesNewRouteImport } from './routes/_authenticated/invoices.new'
import { Route as AuthenticatedPeopleIndexRouteImport } from './routes/_authenticated/people.index'
import { Route as AuthenticatedPeoplePersonIdRouteImport } from './routes/_authenticated/people.$personId'
import { Route as AuthenticatedPeopleNewRouteImport } from './routes/_authenticated/people.new'
import { Route as AuthenticatedServicesServiceIdRouteImport } from './routes/_authenticated/services_.$serviceId'
import { Route as AuthenticatedClientGroupsGroupIdPricingRouteImport } from './routes/_authenticated/client-groups_.$groupId_.pricing'
import { Route as AuthenticatedCompaniesCompanyIdServicesRouteImport } from './routes/_authenticated/companies_.$companyId.services'
import { Route as AuthenticatedFeeSchedulesScheduleIdVersionsEffectiveFromRouteImport } from './routes/_authenticated/fee-schedules_.$scheduleId.versions.$effectiveFrom'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAfrRoute = AuthenticatedAfrRouteImport.update({
  id: '/afr',
  path: '/afr',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAttendanceRoute = AuthenticatedAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedBankAccountsRoute =
  AuthenticatedBankAccountsRouteImport.update({
    id: '/bank-accounts',
    path: '/bank-accounts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedClientGroupsRoute =
  AuthenticatedClientGroupsRouteImport.update({
    id: '/client-groups',
    path: '/client-groups',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompaniesRoute = AuthenticatedCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedContactsRoute = AuthenticatedContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedEmployeesRoute = AuthenticatedEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedInvoiceNotesRoute =
  AuthenticatedInvoiceNotesRouteImport.update({
    id: '/invoice-notes',
    path: '/invoice-notes',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLeaveRoute = AuthenticatedLeaveRouteImport.update({
  id: '/leave',
  path: '/leave',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPayslipsRoute = AuthenticatedPayslipsRouteImport.update({
  id: '/payslips',
  path: '/payslips',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedServiceBundlesRoute =
  AuthenticatedServiceBundlesRouteImport.update({
    id: '/service-bundles',
    path: '/service-bundles',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedServicesRoute = AuthenticatedServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedVirrginRoute = AuthenticatedVirrginRouteImport.update({
  id: '/virrgin',
  path: '/virrgin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedWorkLogRoute = AuthenticatedWorkLogRouteImport.update({
  id: '/work-log',
  path: '/work-log',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminPayrollSettingsRoute =
  AuthenticatedAdminPayrollSettingsRouteImport.update({
    id: '/admin/payroll-settings',
    path: '/admin/payroll-settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedBulkActionsIndexRoute =
  AuthenticatedBulkActionsIndexRouteImport.update({
    id: '/bulk-actions/',
    path: '/bulk-actions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBulkActionsActionIdRoute =
  AuthenticatedBulkActionsActionIdRouteImport.update({
    id: '/bulk-actions/$actionId',
    path: '/bulk-actions/$actionId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedClientGroupsGroupIdRoute =
  AuthenticatedClientGroupsGroupIdRouteImport.update({
    id: '/client-groups_/$groupId',
    path: '/client-groups/$groupId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdRoute =
  AuthenticatedCompaniesCompanyIdRouteImport.update({
    id: '/companies_/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFeeSchedulesIndexRoute =
  AuthenticatedFeeSchedulesIndexRouteImport.update({
    id: '/fee-schedules/',
    path: '/fee-schedules/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFeeSchedulesScheduleIdRoute =
  AuthenticatedFeeSchedulesScheduleIdRouteImport.update({
    id: '/fee-schedules/$scheduleId',
    path: '/fee-schedules/$scheduleId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInvoiceRunsRunIdRoute =
  AuthenticatedInvoiceRunsRunIdRouteImport.update({
    id: '/invoice-runs/$runId',
    path: '/invoice-runs/$runId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInvoicesIndexRoute =
  AuthenticatedInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInvoicesInvoiceIdRoute =
  AuthenticatedInvoicesInvoiceIdRouteImport.update({
    id: '/invoices/$invoiceId',
    path: '/invoices/$invoiceId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInvoicesNewRoute =
  AuthenticatedInvoicesNewRouteImport.update({
    id: '/invoices/new',
    path: '/invoices/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPeopleIndexRoute =
  AuthenticatedPeopleIndexRouteImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPeoplePersonIdRoute =
  AuthenticatedPeoplePersonIdRouteImport.update({
    id: '/people/$personId',
    path: '/people/$personId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPeopleNewRoute = AuthenticatedPeopleNewRouteImport.update({
  id: '/people/new',
  path: '/people/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedServicesServiceIdRoute =
  AuthenticatedServicesServiceIdRouteImport.update({
    id: '/services_/$serviceId',
    path: '/services/$serviceId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedClientGroupsGroupIdPricingRoute =
  AuthenticatedClientGroupsGroupIdPricingRouteImport.update({
    id: '/client-groups_/$groupId_/pricing',
    path: '/client-groups/$groupId/pricing',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdServicesRoute =
  AuthenticatedCompaniesCompanyIdServicesRouteImport.update({
    id: '/services',
    path: '/services',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any)
const AuthenticatedFeeSchedulesScheduleIdVersionsEffectiveFromRoute =
  AuthenticatedFeeSchedulesScheduleIdVersionsEffectiveFromRouteImport.update({
    id: '/fee-schedules_/$scheduleId/versions/$effectiveFrom',
    path: '/fee-schedules/$scheduleId/versions/$effectiveFrom',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/afr': typeof AuthenticatedAfrRoute
  '/attendance': typeof AuthenticatedAttendanceRoute
  '/bank-accounts': typeof AuthenticatedBankAccountsRoute
  '/client-groups': typeof AuthenticatedClientGroupsRoute
  '/companies': typeof AuthenticatedCompaniesRoute
  '/contacts': typeof AuthenticatedContactsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/employees': typeof AuthenticatedEmployeesRoute
  '/invoice-notes': typeof AuthenticatedInvoiceNotesRoute
  '/leave': typeof AuthenticatedLeaveRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/payslips': typeof AuthenticatedPayslipsRoute
  '/service-bundles': typeof AuthenticatedServiceBundlesRoute
  '/services': typeof AuthenticatedServicesRoute
  '/virrgin': typeof AuthenticatedVirrginRoute
  '/work-log': typeof AuthenticatedWorkLogRoute
  '/admin/payroll-settings': typeof AuthenticatedAdminPayrollSettingsRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/bulk-actions/$actionId': typeof AuthenticatedBulkActionsActionIdRoute
  '/client-groups/$groupId': typeof AuthenticatedClientGroupsGroupIdRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRouteWithChildren
  '/fee-schedules/$scheduleId': typeof AuthenticatedFeeSchedulesScheduleIdRoute
  '/invoice-runs/$runId': typeof AuthenticatedInvoiceRunsRunIdRoute
  '/invoices/$invoiceId': typeof AuthenticatedInvoicesInvoiceIdRoute
  '/invoices/new': typeof AuthenticatedInvoicesNewRoute
  '/people/$personId': typeof AuthenticatedPeoplePersonIdRoute
  '/people/new': typeof AuthenticatedPeopleNewRoute
  '/services/$serviceId': typeof AuthenticatedServicesServiceIdRoute
  '/bulk-actions/': typeof AuthenticatedBulkActionsIndexRoute
  '/fee-schedules/': typeof AuthenticatedFeeSchedulesIndexRoute
  '/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/people/': typeof AuthenticatedPeopleIndexRoute
  '/client-groups/$groupId/pricing': typeof AuthenticatedClientGroupsGroupIdPricingRoute
  '/companies/$companyId/services': typeof AuthenticatedCompaniesCompanyIdServicesRoute
  '/fee-schedules/$scheduleId/versions/$effectiveFrom': typeof AuthenticatedFeeSchedulesScheduleIdVersionsEffectiveFromRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/afr': typeof AuthenticatedAfrRoute
  '/attendance': typeof AuthenticatedAttendanceRoute
  '/bank-accounts': typeof AuthenticatedBankAccountsRoute
  '/client-groups': typeof AuthenticatedClientGroupsRoute
  '/companies': typeof AuthenticatedCompaniesRoute
  '/contacts': typeof AuthenticatedContactsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/employees': typeof AuthenticatedEmployeesRoute
  '/invoice-notes': typeof AuthenticatedInvoiceNotesRoute
  '/leave': typeof AuthenticatedLeaveRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/payslips': typeof AuthenticatedPayslipsRoute
  '/service-bundles': typeof AuthenticatedServiceBundlesRoute
  '/services': typeof AuthenticatedServicesRoute
  '/virrgin': typeof AuthenticatedVirrginRoute
  '/work-log': typeof AuthenticatedWorkLogRoute
  '/admin/payroll-settings': typeof AuthenticatedAdminPayrollSettingsRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/bulk-actions/$actionId': typeof AuthenticatedBulkActionsActionIdRoute
  '/client-groups/$groupId': typeof AuthenticatedClientGroupsGroupIdRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRouteWithChildren
  '/fee-schedules/$scheduleId': typeof AuthenticatedFeeSchedulesScheduleIdRoute
  '/invoice-runs/$runId': typeof AuthenticatedInvoiceRunsRunIdRoute
  '/invoices/$invoiceId': typeof AuthenticatedInvoicesInvoiceIdRoute
  '/invoices/new': typeof AuthenticatedInvoicesNewRoute
  '/people/$personId': typeof AuthenticatedPeoplePersonIdRoute
  '/people/new': typeof AuthenticatedPeopleNewRoute
  '/services/$serviceId': typeof AuthenticatedServicesServiceIdRoute
  '/bulk-actions': typeof AuthenticatedBulkActionsIndexRoute
  '/fee-schedules': typeof AuthenticatedFeeSchedulesIndexRoute
  '/invoices': typeof AuthenticatedInvoicesIndexRoute
  '/people': typeof AuthenticatedPeopleIndexRoute
  '/client-groups/$groupId/pricing': typeof AuthenticatedClientGroupsGroupIdPricingRoute
  '/companies/$companyId/services': typeof AuthenticatedCompaniesCompanyIdServicesRoute
  '/fee-schedules/$scheduleId/versions/$effectiveFrom': typeof AuthenticatedFeeSchedulesScheduleIdVersionsEffectiveFromRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/_authenticated/afr': typeof AuthenticatedAfrRoute
  '/_authenticated/attendance': typeof AuthenticatedAttendanceRoute
  '/_authenticated/bank-accounts': typeof AuthenticatedBankAccountsRoute
  '/_authenticated/client-groups': typeof AuthenticatedClientGroupsRoute
  '/_authenticated/companies': typeof AuthenticatedCompaniesRoute
  '/_authenticated/contacts': typeof AuthenticatedContactsRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/employees': typeof AuthenticatedEmployeesRoute
  '/_authenticated/invoice-notes': typeof AuthenticatedInvoiceNotesRoute
  '/_authenticated/leave': typeof AuthenticatedLeaveRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/payslips': typeof AuthenticatedPayslipsRoute
  '/_authenticated/service-bundles': typeof AuthenticatedServiceBundlesRoute
  '/_authenticated/services': typeof AuthenticatedServicesRoute
  '/_authenticated/virrgin': typeof AuthenticatedVirrginRoute
  '/_authenticated/work-log': typeof AuthenticatedWorkLogRoute
  '/_authenticated/admin/payroll-settings': typeof AuthenticatedAdminPayrollSettingsRoute
  '/_authenticated/admin/users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/bulk-actions/$actionId': typeof AuthenticatedBulkActionsActionIdRoute
  '/_authenticated/client-groups_/$groupId': typeof AuthenticatedClientGroupsGroupIdRoute
  '/_authenticated/companies_/$companyId': typeof AuthenticatedCompaniesCompanyIdRouteWithChildren
  '/_authenticated/fee-schedules/$scheduleId': typeof AuthenticatedFeeSchedulesScheduleIdRoute
  '/_authenticated/invoice-runs/$runId': typeof AuthenticatedInvoiceRunsRunIdRoute
  '/_authenticated/invoices/$invoiceId': typeof AuthenticatedInvoicesInvoiceIdRoute
  '/_authenticated/invoices/new': typeof AuthenticatedInvoicesNewRoute
  '/_authenticated/people/$personId': typeof AuthenticatedPeoplePersonIdRoute
  '/_authenticated/people/new': typeof AuthenticatedPeopleNewRoute
  '/_authenticated/services_/$serviceId': typeof AuthenticatedServicesServiceIdRoute
  '/_authenticated/bulk-actions/': typeof AuthenticatedBulkActionsIndexRoute
  '/_authenticated/fee-schedules/': typeof AuthenticatedFeeSchedulesIndexRoute
  '/_authenticated/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/_authenticated/people/': typeof AuthenticatedPeopleIndexRoute
  '/_authenticated/client-groups_/$groupId_/pricing': typeof AuthenticatedClientGroupsGroupIdPricingRoute
  '/_authenticated/companies_/$companyId/services': typeof AuthenticatedCompaniesCompanyIdServicesRoute
  '/_authenticated/fee-schedules_/$scheduleId/versions/$effectiveFrom': typeof AuthenticatedFeeSchedulesScheduleIdVersionsEffectiveFromRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/afr'
    | '/attendance'
    | '/bank-accounts'
    | '/client-groups'
    | '/companies'
    | '/contacts'
    | '/dashboard'
    | '/employees'
    | '/invoice-notes'
    | '/leave'
    | '/notifications'
    | '/payslips'
    | '/service-bundles'
    | '/services'
    | '/virrgin'
    | '/work-log'
    | '/admin/payroll-settings'
    | '/admin/users'
    | '/bulk-actions/$actionId'
    | '/client-groups/$groupId'
    | '/companies/$companyId'
    | '/fee-schedules/$scheduleId'
    | '/invoice-runs/$runId'
    | '/invoices/$invoiceId'
    | '/invoices/new'
    | '/people/$personId'
    | '/people/new'
    | '/services/$serviceId'
    | '/bulk-actions/'
    | '/fee-schedules/'
    | '/invoices/'
    | '/people/'
    | '/client-groups/$groupId/pricing'
    | '/companies/$companyId/services'
    | '/fee-schedules/$scheduleId/versions/$effectiveFrom'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/afr'
    | '/attendance'
    | '/bank-accounts'
    | '/client-groups'
    | '/companies'
    | '/contacts'
    | '/dashboard'
    | '/employees'
    | '/invoice-notes'
    | '/leave'
    | '/notifications'
    | '/payslips'
    | '/service-bundles'
    | '/services'
    | '/virrgin'
    | '/work-log'
    | '/admin/payroll-settings'
    | '/admin/users'
    | '/bulk-actions/$actionId'
    | '/client-groups/$groupId'
    | '/companies/$companyId'
    | '/fee-schedules/$scheduleId'
    | '/invoice-runs/$runId'
    | '/invoices/$invoiceId'
    | '/invoices/new'
    | '/people/$personId'
    | '/people/new'
    | '/services/$serviceId'
    | '/bulk-actions'
    | '/fee-schedules'
    | '/invoices'
    | '/people'
    | '/client-groups/$groupId/pricing'
    | '/companies/$companyId/services'
    | '/fee-schedules/$scheduleId/versions/$effectiveFrom'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/auth'
    | '/_authenticated/afr'
    | '/_authenticated/attendance'
    | '/_authenticated/bank-accounts'
    | '/_authenticated/client-groups'
    | '/_authenticated/companies'
    | '/_authenticated/contacts'
    | '/_authenticated/dashboard'
    | '/_authenticated/employees'
    | '/_authenticated/invoice-notes'
    | '/_authenticated/leave'
    | '/_authenticated/notifications'
    | '/_authenticated/payslips'
    | '/_authenticated/service-bundles'
    | '/_authenticated/services'
    | '/_authenticated/virrgin'
    | '/_authenticated/work-log'
    | '/_authenticated/admin/payroll-settings'
    | '/_authenticated/admin/users'
    | '/_authenticated/bulk-actions/$actionId'
    | '/_authenticated/client-groups_/$groupId'
    | '/_authenticated/companies_/$companyId'
    | '/_authenticated/fee-schedules/$scheduleId'
    | '/_authenticated/invoice-runs/$runId'
    | '/_authenticated/invoices/$invoiceId'
    | '/_authenticated/invoices/new'
    | '/_authenticated/people/$personId'
    | '/_authenticated/people/new'
    | '/_authenticated/services_/$serviceId'
    | '/_authenticated/bulk-actions/'
    | '/_authenticated/fee-schedules/'
    | '/_authenticated/invoices/'
    | '/_authenticated/people/'
    | '/_authenticated/client-groups_/$groupId_/pricing'
    | '/_authenticated/companies_/$companyId/services'
    | '/_authenticated/fee-schedules_/$scheduleId/versions/$effectiveFrom'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthRoute: typeof AuthRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/afr': {
      id: '/_authenticated/afr'
      path: '/afr'
      fullPath: '/afr'
      preLoaderRoute: typeof AuthenticatedAfrRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/attendance': {
      id: '/_authenticated/attendance'
      path: '/attendance'
      fullPath: '/attendance'
      preLoaderRoute: typeof AuthenticatedAttendanceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/bank-accounts': {
      id: '/_authenticated/bank-accounts'
      path: '/bank-accounts'
      fullPath: '/bank-accounts'
      preLoaderRoute: typeof AuthenticatedBankAccountsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/client-groups': {
      id: '/_authenticated/client-groups'
      path: '/client-groups'
      fullPath: '/client-groups'
      preLoaderRoute: typeof AuthenticatedClientGroupsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/companies': {
      id: '/_authenticated/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AuthenticatedCompaniesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/contacts': {
      id: '/_authenticated/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthenticatedContactsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/employees': {
      id: '/_authenticated/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AuthenticatedEmployeesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/invoice-notes': {
      id: '/_authenticated/invoice-notes'
      path: '/invoice-notes'
      fullPath: '/invoice-notes'
      preLoaderRoute: typeof AuthenticatedInvoiceNotesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leave': {
      id: '/_authenticated/leave'
      path: '/leave'
      fullPath: '/leave'
      preLoaderRoute: typeof AuthenticatedLeaveRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/payslips': {
      id: '/_authenticated/payslips'
      path: '/payslips'
      fullPath: '/payslips'
      preLoaderRoute: typeof AuthenticatedPayslipsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/service-bundles': {
      id: '/_authenticated/service-bundles'
      path: '/service-bundles'
      fullPath: '/service-bundles'
      preLoaderRoute: typeof AuthenticatedServiceBundlesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/services': {
      id: '/_authenticated/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof AuthenticatedServicesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/virrgin': {
      id: '/_authenticated/virrgin'
      path: '/virrgin'
      fullPath: '/virrgin'
      preLoaderRoute: typeof AuthenticatedVirrginRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/work-log': {
      id: '/_authenticated/work-log'
      path: '/work-log'
      fullPath: '/work-log'
      preLoaderRoute: typeof AuthenticatedWorkLogRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/payroll-settings': {
      id: '/_authenticated/admin/payroll-settings'
      path: '/admin/payroll-settings'
      fullPath: '/admin/payroll-settings'
      preLoaderRoute: typeof AuthenticatedAdminPayrollSettingsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/users': {
      id: '/_authenticated/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/bulk-actions/': {
      id: '/_authenticated/bulk-actions/'
      path: '/bulk-actions'
      fullPath: '/bulk-actions/'
      preLoaderRoute: typeof AuthenticatedBulkActionsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/bulk-actions/$actionId': {
      id: '/_authenticated/bulk-actions/$actionId'
      path: '/bulk-actions/$actionId'
      fullPath: '/bulk-actions/$actionId'
      preLoaderRoute: typeof AuthenticatedBulkActionsActionIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/client-groups_/$groupId': {
      id: '/_authenticated/client-groups_/$groupId'
      path: '/client-groups/$groupId'
      fullPath: '/client-groups/$groupId'
      preLoaderRoute: typeof AuthenticatedClientGroupsGroupIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/companies_/$companyId': {
      id: '/_authenticated/companies_/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/fee-schedules/': {
      id: '/_authenticated/fee-schedules/'
      path: '/fee-schedules'
      fullPath: '/fee-schedules/'
      preLoaderRoute: typeof AuthenticatedFeeSchedulesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/fee-schedules/$scheduleId': {
      id: '/_authenticated/fee-schedules/$scheduleId'
      path: '/fee-schedules/$scheduleId'
      fullPath: '/fee-schedules/$scheduleId'
      preLoaderRoute: typeof AuthenticatedFeeSchedulesScheduleIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/invoice-runs/$runId': {
      id: '/_authenticated/invoice-runs/$runId'
      path: '/invoice-runs/$runId'
      fullPath: '/invoice-runs/$runId'
      preLoaderRoute: typeof AuthenticatedInvoiceRunsRunIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/invoices/': {
      id: '/_authenticated/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthenticatedInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/invoices/$invoiceId': {
      id: '/_authenticated/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof AuthenticatedInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/invoices/new': {
      id: '/_authenticated/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AuthenticatedInvoicesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/people/': {
      id: '/_authenticated/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof AuthenticatedPeopleIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/people/$personId': {
      id: '/_authenticated/people/$personId'
      path: '/people/$personId'
      fullPath: '/people/$personId'
      preLoaderRoute: typeof AuthenticatedPeoplePersonIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/people/new': {
      id: '/_authenticated/people/new'
      path: '/people/new'
      fullPath: '/people/new'
      preLoaderRoute: typeof AuthenticatedPeopleNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/services_/$serviceId': {
      id: '/_authenticated/services_/$serviceId'
      path: '/services/$serviceId'
      fullPath: '/services/$serviceId'
      preLoaderRoute: typeof AuthenticatedServicesServiceIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/client-groups_/$groupId_/pricing': {
      id: '/_authenticated/client-groups_/$groupId_/pricing'
      path: '/client-groups/$groupId/pricing'
      fullPath: '/client-groups/$groupId/pricing'
      preLoaderRoute: typeof AuthenticatedClientGroupsGroupIdPricingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/companies_/$companyId/services': {
      id: '/_authenticated/companies_/$companyId/services'
      path: '/services'
      fullPath: '/companies/$companyId/services'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdServicesRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/fee-schedules_/$scheduleId/versions/$effectiveFrom': {
      id: '/_authenticated/fee-schedules_/$scheduleId/versions/$effectiveFrom'
      path: '/fee-schedules/$scheduleId/versions/$effectiveFrom'
      fullPath: '/fee-schedules/$scheduleId/versions/$effectiveFrom'
      preLoaderRoute: typeof AuthenticatedFeeSchedulesScheduleIdVersionsEffectiveFromRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedCompaniesCompanyIdRouteChildren {
  AuthenticatedCompaniesCompanyIdServicesRoute: typeof AuthenticatedCompaniesCompanyIdServicesRoute
}

const AuthenticatedCompaniesCompanyIdRouteChildren: AuthenticatedCompaniesCompanyIdRouteChildren =
  {
    AuthenticatedCompaniesCompanyIdServicesRoute:
      AuthenticatedCompaniesCompanyIdServicesRoute,
  }

const AuthenticatedCompaniesCompanyIdRouteWithChildren =
  AuthenticatedCompaniesCompanyIdRoute._addFileChildren(
    AuthenticatedCompaniesCompanyIdRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAfrRoute: typeof AuthenticatedAfrRoute
  AuthenticatedAttendanceRoute: typeof AuthenticatedAttendanceRoute
  AuthenticatedBankAccountsRoute: typeof AuthenticatedBankAccountsRoute
  AuthenticatedClientGroupsRoute: typeof AuthenticatedClientGroupsRoute
  AuthenticatedCompaniesRoute: typeof AuthenticatedCompaniesRoute
  AuthenticatedContactsRoute: typeof AuthenticatedContactsRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedEmployeesRoute: typeof AuthenticatedEmployeesRoute
  AuthenticatedInvoiceNotesRoute: typeof AuthenticatedInvoiceNotesRoute
  AuthenticatedLeaveRoute: typeof AuthenticatedLeaveRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedPayslipsRoute: typeof AuthenticatedPayslipsRoute
  AuthenticatedServiceBundlesRoute: typeof AuthenticatedServiceBundlesRoute
  AuthenticatedServicesRoute: typeof AuthenticatedServicesRoute
  AuthenticatedVirrginRoute: typeof AuthenticatedVirrginRoute
  AuthenticatedWorkLogRoute: typeof AuthenticatedWorkLogRoute
  AuthenticatedAdminPayrollSettingsRoute: typeof AuthenticatedAdminPayrollSettingsRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
  AuthenticatedBulkActionsActionIdRoute: typeof AuthenticatedBulkActionsActionIdRoute
  AuthenticatedClientGroupsGroupIdRoute: typeof AuthenticatedClientGroupsGroupIdRoute
  AuthenticatedCompaniesCompanyIdRoute: typeof AuthenticatedCompaniesCompanyIdRouteWithChildren
  AuthenticatedFeeSchedulesScheduleIdRoute: typeof AuthenticatedFeeSchedulesScheduleIdRoute
  AuthenticatedInvoiceRunsRunIdRoute: typeof AuthenticatedInvoiceRunsRunIdRoute
  AuthenticatedInvoicesInvoiceIdRoute: typeof AuthenticatedInvoicesInvoiceIdRoute
  AuthenticatedInvoicesNewRoute: typeof AuthenticatedInvoicesNewRoute
  AuthenticatedPeoplePersonIdRoute: typeof AuthenticatedPeoplePersonIdRoute
  AuthenticatedPeopleNewRoute: typeof AuthenticatedPeopleNewRoute
  AuthenticatedServicesServiceIdRoute: typeof AuthenticatedServicesServiceIdRoute
  AuthenticatedBulkActionsIndexRoute: typeof AuthenticatedBulkActionsIndexRoute
  AuthenticatedFeeSchedulesIndexRoute: typeof AuthenticatedFeeSchedulesIndexRoute
  AuthenticatedInvoicesIndexRoute: typeof AuthenticatedInvoicesIndexRoute
  AuthenticatedPeopleIndexRoute: typeof AuthenticatedPeopleIndexRoute
  AuthenticatedClientGroupsGroupIdPricingRoute: typeof AuthenticatedClientGroupsGroupIdPricingRoute
  AuthenticatedFeeSchedulesScheduleIdVersionsEffectiveFromRoute: typeof AuthenticatedFeeSchedulesScheduleIdVersionsEffectiveFromRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAfrRoute: AuthenticatedAfrRoute,
  AuthenticatedAttendanceRoute: AuthenticatedAttendanceRoute,
  AuthenticatedBankAccountsRoute: AuthenticatedBankAccountsRoute,
  AuthenticatedClientGroupsRoute: AuthenticatedClientGroupsRoute,
  AuthenticatedCompaniesRoute: AuthenticatedCompaniesRoute,
  AuthenticatedContactsRoute: AuthenticatedContactsRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedEmployeesRoute: AuthenticatedEmployeesRoute,
  AuthenticatedInvoiceNotesRoute: AuthenticatedInvoiceNotesRoute,
  AuthenticatedLeaveRoute: AuthenticatedLeaveRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedPayslipsRoute: AuthenticatedPayslipsRoute,
  AuthenticatedServiceBundlesRoute: AuthenticatedServiceBundlesRoute,
  AuthenticatedServicesRoute: AuthenticatedServicesRoute,
  AuthenticatedVirrginRoute: AuthenticatedVirrginRoute,
  AuthenticatedWorkLogRoute: AuthenticatedWorkLogRoute,
  AuthenticatedAdminPayrollSettingsRoute:
    AuthenticatedAdminPayrollSettingsRoute,
  AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
  AuthenticatedBulkActionsActionIdRoute: AuthenticatedBulkActionsActionIdRoute,
  AuthenticatedClientGroupsGroupIdRoute: AuthenticatedClientGroupsGroupIdRoute,
  AuthenticatedCompaniesCompanyIdRoute:
    AuthenticatedCompaniesCompanyIdRouteWithChildren,
  AuthenticatedFeeSchedulesScheduleIdRoute:
    AuthenticatedFeeSchedulesScheduleIdRoute,
  AuthenticatedInvoiceRunsRunIdRoute: AuthenticatedInvoiceRunsRunIdRoute,
  AuthenticatedInvoicesInvoiceIdRoute: AuthenticatedInvoicesInvoiceIdRoute,
  AuthenticatedInvoicesNewRoute: AuthenticatedInvoicesNewRoute,
  AuthenticatedPeoplePersonIdRoute: AuthenticatedPeoplePersonIdRoute,
  AuthenticatedPeopleNewRoute: AuthenticatedPeopleNewRoute,
  AuthenticatedServicesServiceIdRoute: AuthenticatedServicesServiceIdRoute,
  AuthenticatedBulkActionsIndexRoute: AuthenticatedBulkActionsIndexRoute,
  AuthenticatedFeeSchedulesIndexRoute: AuthenticatedFeeSchedulesIndexRoute,
  AuthenticatedInvoicesIndexRoute: AuthenticatedInvoicesIndexRoute,
  AuthenticatedPeopleIndexRoute: AuthenticatedPeopleIndexRoute,
  AuthenticatedClientGroupsGroupIdPricingRoute:
    AuthenticatedClientGroupsGroupIdPricingRoute,
  AuthenticatedFeeSchedulesScheduleIdVersionsEffectiveFromRoute:
    AuthenticatedFeeSchedulesScheduleIdVersionsEffectiveFromRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthRoute: AuthRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
